(function () {
    'use strict';
    $(document).ready(function () {

        const controller = new ScrollMagic.Controller();
        const JRElements = $('.just-reveal');
        const totalJRElements = JRElements.length;

        JRElements.each(function (index) {
            const $this = $(this);
            // const uniqID = Math.random().toString(36).substr(2, 9);
            // $this.attr('data-jr-uniqid', uniqID);
            // const target = document.querySelector(`.just-reveal[data-jr-uniqid="${uniqID}"]`);
            const target = $this[0];

            let triggerHook = 0.7; // default one for all elements

            if ($('footer').has($this) || $this.height() > $(window).height() * .7) // for footer elements
                triggerHook = .7;

            if ($('.posts').has($this) && $this.hasClass('pagination')) // for posts pagination
                triggerHook = .95;

            if (index === totalJRElements - 1) // for last animation element
                triggerHook = .95;

            new ScrollMagic.Scene({
                triggerElement: target,
                triggerHook: triggerHook,
            })
                .on('enter', function () {
                    target.classList.add('jr-running');
                    if ($(target).find('.jr-count:not(.jr-running)').length)
                        countFromZero($(target).find('.jr-count:not(.jr-running)'));
                })
                .addTo(controller);
                // .addIndicators();

        });

    });
}(jQuery));
